/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tumblr': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#2f4f6e" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M23.626 23.176v3.918l-.022.009c-.466.218-.939.418-1.42.6a11.395 11.395 0 01-3.552.726c-.108.004-.216.011-.324.017-.237 0-.741-.006-.758-.007-.378-.01-.753-.04-1.128-.089a8.165 8.165 0 01-1.797-.44c-.925-.345-1.74-.857-2.415-1.582-.524-.563-.875-1.211-1.014-1.972a9.85 9.85 0 01-.147-1.756c-.002-2.922-.001-5.911-.001-8.833H8.375v-3.563c.296-.117.593-.219.881-.353 1.526-.709 2.642-1.832 3.35-3.357.346-.747.541-1.54.675-2.349.033-.196.058-.394.087-.591h3.53l.001 6.306h5.905v3.908h-5.908s.004 6.952.009 7.184c.013.528.038 1.055.119 1.579.087.563.369.999.843 1.311.464.305.977.48 1.529.539a5.34 5.34 0 001.634-.092c.943-.19 1.798-.586 2.598-1.113z"/>'
  }
})
